@if (showMandatoryMessage | async) {
  <div class="red">{{'CUSTOMIZER.STATISTICS.MANDATORYMESSAGE' | translate}}</div>
}

<b>{{'CUSTOMIZER.STATISTICS.INFO' | translate}}</b>

<br />
<br />

<div class="margin-top margin-bottom">{{'CUSTOMIZER.STATISTICS.AGE' | translate}}</div>
<selectable-button [defaultValue]="age" [options]="ages" [optionsText]="ageOptionsText" [optionalText]="'–'" [optionGroupHeader]="optionGroupHeaderVoid" [optionGroupCount]="1" (valueChange)="ageChange.next($event)" [id]="'selectableButton'"></selectable-button>

<br />

<div>{{'CUSTOMIZER.STATISTICS.GENDER' | translate}}</div>
@for (g of genders | keyvalue; track g) {
  <checkbox [label]="'CUSTOMIZER.STATISTICS.GENDER.' + g.key | translate" [radio]="true" [checked]="gender === g.value" (checkedChange)="genderChange.next(gender !== g.value ? g.value : null)"></checkbox>
}

<br />

<div [innerHTML]="'CUSTOMIZER.STATISTICS.FIRSTPAIR' | translate"></div>
@for (f of firstPairs | keyvalue; track f) {
  <checkbox [label]="'CUSTOMIZER.STATISTICS.FIRSTPAIR.' + f.key | translate" [radio]="true" [checked]="firstPair === f.value" (checkedChange)="firstPairChange.next(firstPair !== f.value ? f.value : null)"></checkbox>
}